export interface ParticipantFullName {
  titleKey: string | null
  firstName: string
  lastName: string
}

export function formatParticipantFullName(resolvedTitle: string | null, firstName: string, lastName: string): string {
  return [resolvedTitle, firstName, lastName].filter(Boolean).join(' ')
}

export function getSupportedParticipantTitle(title: string): string | null {
  const normalizedTitle = title
    .trim()
    .toLowerCase()
    .replaceAll('.', '')

  if (normalizedTitle === 'mr') {
    return 'booking_details_participant_title_mr'
  }

  if (normalizedTitle === 'ms' || normalizedTitle === 'mrs') {
    return 'booking_details_participant_title_ms'
  }

  return null
}
